var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostPurchaseScreen',{attrs:{"title":"THANK YOU!","body":"Thanks for placing your order! Keep an eye on your email and we'll email you when a pro has confirmed your appointment(s)"}})}
var staticRenderFns = []

export { render, staticRenderFns }